import { useAction } from "@/hooks/shared";
import { updateCompanyProfileHandler } from "@/services";

export const useUpdateCompanyProfile = () => useAction(updateCompanyProfileHandler);
